import { useEffect, useRef, useState } from "react";
import Apiservice from "../Apiservice";
import moment from "moment";
import { PDFDownloadLink, Select } from "@react-pdf/renderer";
import AttendanceReportPDF from "./AttendanceReportPDF";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import TimesheetPDF from "./TimesheetPDF";
import { FaFileExcel, FaFilePdf, FaSearch, FaUndo } from "react-icons/fa";
import Swal from "sweetalert2";
import { exportToExcel } from "./TimeSheetExcel";

const TimeSheet = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const fromRef = useRef("");
    const toRef = useRef("");
    const employeeIdRef = useRef(0);
    const [userDetails, setUserDetails] = useState([]);
    const [errors, setErrors] = useState({});
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [allUsers, setAllUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [remarks, setRemarks] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            let data = {
                "status": 0
            };
            let result = await Apiservice.RemarksGet(data);
            console.log("result", result);
            if (result.success === true) {
                setRemarks(result.data);
            }
            else {
                alert(result.message);
            }
        };
        fetchData();

    }, [])


    const validateForm = () => {
        const newErrors = {};
        if (!fromRef.current.value.trim()) newErrors.from = "From Date is required";
        if (!toRef.current.value.trim()) newErrors.to = "To Date is required";
        if (!employeeIdRef.current.value.trim()) newErrors.employeeId = "employee Id is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const fetchData = async () => {
        if (!validateForm()) return;

        const requestData = {
            entryTimeFrom: fromRef.current.value,
            entryTimeTo: toRef.current.value,
            breakHours: '2:00:00',
            status: 0,
            employeeId: employeeIdRef.current.value,
        };

        try {
            let result = await Apiservice.TimeSheet(requestData);
            //console.log("result", result);

            if (result.success) {
                let retrievedData = result.data;
                setData(retrievedData.timesheet);
                setUserDetails(retrievedData.userDetails)
            } else {
                console.error(result.message);
                setData([]);
                setUserDetails([]);
                alert(result.message)
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setData([]); // In case server itself fails
            setUserDetails([]);
        }
    };

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    const handleReset = () => {
        fromRef.current.value = "";
        toRef.current.value = "";
        employeeIdRef.current.value = "";

        setErrors({});
        setData([]);
        setUserDetails({});
    };


    const handleEdit = (rowId) => {
        setEditingId(rowId);
    };


    const handleUpdate = async (row) => {
        try {
            console.log("row", row)
            let result;

            if (row.rowId.startsWith("A_")) {

                result = await Apiservice.UpdateAttendance({
                    attendanceId: row.id,
                    status: 0,
                    remarkId: Number(row.remarkId),
                    otherReason: row.otherReason
                });

            } else if (row.rowId.startsWith("L_")) {

                result = await Apiservice.TimesheetRemarksUpdate({
                    ...(row.hasRemark === true && {
                        timeSheetRemarksId: row.timeSheetRemark.id
                    }),

                    userId: userDetails?.id,
                    workDate: row.date,
                    leaveApplicationId: row.leaveApplicationId,
                    remarkId: Number(row.remarkId),
                    otherReason: row.otherReason,
                    status: 0
                });

            } else if (row.rowId.startsWith("M_")) {
                console.log("Mising")
                result = await Apiservice.TimesheetRemarksUpdate({
                    ...(row.hasRemark === true && {
                        timeSheetRemarksId: row.timeSheetRemark.id
                    }),

                    userId: userDetails?.id,
                    workDate: row.date,
                    remarkId: Number(row.remarkId),
                    otherReason: row.otherReason,
                    status: 0
                });

                console.log("result", result)

            } else {
                return Swal.fire({
                    icon: "warning",
                    title: "Invalid Record",
                    text: "Unknown row type."
                });
            }

            if (result?.success) {
                await Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: result.message,
                    timer: 1500,
                    showConfirmButton: false
                });

                setEditingId("");
                fetchData();

                // தேவையெனில் data reload
                // getTimeSheet();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Failed",
                    text: result?.message || "Something went wrong."
                });
            }

        } catch (err) {
            console.error(err);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: err?.message || "Unexpected error occurred."
            });
        }
    };

    // const handleDeleteConfirm = async (attendanceId) => {
    //     const data = {
    //         'attendanceId': attendanceId,
    //         'status': 0
    //     };
    //     const token = localStorage.getItem("access_token");

    //     const headers = {
    //         access_token: token,
    //     };

    //     let result = await Apiservice.SoftDeleteAttendance(data);
    //     if (result.success === true) {
    //         setDeleteModal(false);
    //         setSelectedId(null); // Reset selected ID
    //         await fetchData(); // ✅ Refresh the data directly
    //     } else {
    //         alert(result.message);
    //     }
    // };

    const handleDeleteConfirm = async () => {

        if (!selectedRow) return;

        const data = {

            attendance: selectedRow.attendance,

            leave: selectedRow.leave,

            attendanceId: selectedRow.attendanceId,

            leaveApplicationId: selectedRow.leaveApplicationId,

            workDate: selectedRow.date

        };

        // const result = await ApiService.DeleteTimesheetRemark(data);

        // if (result.success) {

        //     setDeleteModal(false);

        //     setSelectedRow(null);

        //     setEditingId("");

        //     fetchData();

        // }

    };

    const handleRemarkChange = (rowId, value) => {
        setData(prev =>
            prev.map(item =>
                item.rowId === rowId
                    ? { ...item, remarkId: value }
                    : item
            )
        );
    };

    const handleOtherReasonChange = (rowId, value) => {
        setData(prev =>
            prev.map(item =>
                item.rowId === rowId
                    ? {
                        ...item,
                        otherReason: value
                    }
                    : item
            )
        );
    };



    // const exportToExcel = () => {
    //     if (!data.length) return;

    //     const exportData = data.map((d, index) => ({
    //         SNo: index + 1,
    //         ...(employeeIdRef.current.value <= 0 && {
    //             StaffID: d.user_id,
    //             Name: `${d.userDetails?.firstName || ""} ${d.userDetails?.lastName || ""}`,
    //             Designation: d.userDetails?.roleName || "N/A",
    //         }),
    //         Day: d.day,
    //         DateIn: d.dateIn,
    //         TimeIn: d.timeIn || "-",
    //         DateOut: d.dateOut,
    //         TimeOut: d.timeOut || "-",
    //         "Duration Of Break (Hour)": d.breakHours,
    //         Remarks: d.timeSheetRemark?.remarks || "",
    //         "Other Reason": d.otherReason || d.timeSheetRemark?.otherReason || "",
    //     }));

    //     const worksheet = XLSX.utils.json_to_sheet(exportData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");

    //     XLSX.writeFile(workbook, "Attendance_Report.xlsx");
    // };

    return (
        <div className="container-fluid p-3 shadow" style={{ backgroundColor: "#f8f9fa", userSelect: "none" }}>
            {/* Search Section */}
            {/* Search Section */}
            <div
                className="card shadow-sm border-0 sticky-top"
                style={{
                    top: "0px",
                    zIndex: 100,
                    borderRadius: "15px",
                }}
            >
                <div className="card-body">
                    <div className="row g-3 align-items-end">

                        {/* From */}
                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                            <label className="form-label fw-semibold">From</label>
                            <input
                                type="date"
                                className={`form-control ${errors.from ? "is-invalid" : ""}`}
                                ref={fromRef}
                            />
                            {errors.from && (
                                <div className="invalid-feedback">{errors.from}</div>
                            )}
                        </div>

                        {/* To */}
                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                            <label className="form-label fw-semibold">To</label>
                            <input
                                type="date"
                                className={`form-control ${errors.to ? "is-invalid" : ""}`}
                                ref={toRef}
                            />
                            {errors.to && (
                                <div className="invalid-feedback">{errors.to}</div>
                            )}
                        </div>

                        {/* User ID */}
                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                            <label className="form-label fw-semibold">
                                Employee ID
                            </label>
                            <input
                                type="text"
                                className={`form-control ${errors.employeeId ? "is-invalid" : ""}`}
                                ref={employeeIdRef}
                                placeholder="Enter Employee ID"
                            />
                            {errors.userId && (
                                <div className="invalid-feedback">{errors.employeeId}</div>
                            )}
                        </div>

                        {/* Buttons */}
                        <div className="col-xl-3 col-lg-12 col-md-12">
                            <div className="d-flex align-items-center gap-2 flex-wrap justify-content-lg-end">

                                {/* Search */}
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    onClick={fetchData}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm me-2"
                                                role="status"
                                            />
                                            Loading...
                                        </>
                                    ) : (
                                        <>
                                            <FaSearch className="me-1" />
                                            Search
                                        </>
                                    )}
                                </button>

                                {/* Reset */}
                                <button
                                    className="btn btn-secondary d-flex align-items-center"
                                    onClick={handleReset}
                                >
                                    <FaUndo className="me-1" />
                                    Reset
                                </button>

                                {/* Excel */}
                                {data.length > 0 && (
                                    <button
                                        className="btn btn-success d-flex align-items-center justify-content-center"
                                        // onClick={exportToExcel}
                                        onClick={() =>
                                            exportToExcel(
                                                data,
                                                userDetails,
                                                employeeIdRef.current.value,
                                                fromRef.current.value,
                                                toRef.current.value
                                            )
                                        }
                                        title="Download Excel"
                                        style={{
                                            width: "42px",
                                            height: "38px",
                                        }}
                                    >
                                        <FaFileExcel />
                                    </button>
                                )}

                                {/* PDF */}
                                {data.length > 0 && (
                                    <PDFDownloadLink
                                        document={
                                            <TimesheetPDF
                                                data={data}
                                                employeeId={parseInt(employeeIdRef.current?.value)}
                                                from={fromRef.current?.value}
                                                to={toRef.current?.value}
                                                timeSheet={TimeSheet}
                                                userDetails={userDetails}
                                            />
                                        }
                                        fileName={`${userDetails?.firstName || ""} ${userDetails?.lastName || ""}_TimeSheet.pdf`}
                                        className="btn btn-danger d-flex align-items-center justify-content-center"
                                        style={{
                                            width: "42px",
                                            height: "38px",
                                            textDecoration: "none",
                                        }}
                                    >
                                        {({ loading }) =>
                                            loading ? (
                                                <span className="spinner-border spinner-border-sm"></span>
                                            ) : (
                                                <FaFilePdf />
                                            )
                                        }
                                    </PDFDownloadLink>
                                )}

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Data Display Section */}
            <div className="row mt-4">
                <div className="col-12">
                    {
                        userDetails.id && (
                            <div className="card mb-4">
                                <div className="card-body d-flex align-items-center">
                                    <img
                                        src={userDetails?.profileImage || ""}
                                        alt="Profile"
                                        className="rounded-circle me-3"
                                        style={{ width: "80px", height: "80px", objectFit: "cover" }}
                                    />
                                    <div>
                                        <h5 className="mb-1">
                                            {`${userDetails?.firstName || ""} ${userDetails?.lastName || ""}`}
                                        </h5>
                                        <p className="mb-1 text-muted">{userDetails?.roleName}</p>
                                        <p className="mb-1 text-muted">Employee ID : {employeeIdRef.current.value}</p>
                                        <p className="mb-1 text-muted">{userDetails?.emailId}</p>
                                        <p className="mb-0 text-muted">
                                            {`${userDetails?.countryCode || ""}${userDetails?.mobileNo || ""}`}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    <div className="table table-responsive">
                        <table className="table table-striped table-hover table-responsive">
                            <thead className="table-dark">
                                <tr>
                                    <th>#</th>
                                    <th>Day</th>
                                    <th>Date In</th>

                                    {/* <th>Site Name</th> */}
                                    {/* <th>Designation</th> */}
                                    <th>Time In</th>
                                    <th>Date Out</th>
                                    <th>Time Out</th>
                                    <th>Duration Of Break</th>
                                    <th>Remarks</th>
                                    <th> If others is selected, please state reason</th>
                                    {/* <th>Total Hours</th> */}
                                    {/* <th>Working Hours</th> */}
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length > 0 ? (
                                    data.map((d, index) => {
                                        //  let state = JSON.parse(d.state); // Correctly placed variable declaration

                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{d.day}</td>
                                                <td>{d.dateIn}</td>

                                                {/* <td>{d.siteDetails[0].name}</td> */}
                                                {/* <td>{d.roleName}</td> */}
                                                <td>{d.timeIn ? d.timeIn : "-"}</td>
                                                <td>{d.dateOut}</td>
                                                <td>{d.timeOut ? d.timeOut : "-"}</td>
                                                <td>{d.breakHours}</td>
                                                <td>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        value={d.remarkId || d.timeSheetRemark?.remarkId || ""}
                                                        disabled={editingId !== d.rowId}
                                                        onChange={(e) => handleRemarkChange(d.rowId, e.target.value)}
                                                    >
                                                        <option value="">Select Remarks</option>

                                                        {remarks.map((item) => (
                                                            <option
                                                                key={item.id}
                                                                value={item.id}
                                                            >
                                                                {item.remarks}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        value={d.otherReason || d.timeSheetRemark?.otherReason || ""}
                                                        disabled={editingId !== d.rowId}
                                                        onChange={(e) => handleOtherReasonChange(d.rowId, e.target.value)}
                                                    />
                                                </td>

                                                {/* <td>{d.totalHours || "N/A"}</td> */}

                                                {/* <td>{d.workingHours || "N/A"}</td> */}
                                                <td>
                                                    {editingId === d.rowId ? (
                                                        <>
                                                            <button
                                                                className="btn btn-sm btn-success me-2"
                                                                onClick={() => handleUpdate(d)}
                                                            >
                                                                Save
                                                            </button>

                                                            <button
                                                                className="btn btn-sm btn-secondary"
                                                                onClick={() => setEditingId("")}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <button
                                                                className="btn btn-sm btn-primary me-2"
                                                                onClick={() => handleEdit(d.rowId)}
                                                            >
                                                                Edit
                                                            </button>

                                                            {/* <button
                                                                className="btn btn-outline-danger btn-sm"
                                                                onClick={() => {
                                                                    setSelectedRow(d);
                                                                    setDeleteModal(true);
                                                                }}
                                                            >
                                                                Delete
                                                            </button> */}
                                                        </>
                                                    )}
                                                </td>
                                            </tr>

                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="11" className="text-center">No Data Found</td>
                                    </tr>
                                )}

                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
            {deleteModal && (
                <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Delete ?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to Delete?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setDeleteModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={() => handleDeleteConfirm(selectedId)}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>

            )}
        </div>
    );
};

export default TimeSheet;
